import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'

export const useEvaluationsMax = () => {
  const user = useSelector(({ monitoring }: IMainState) => monitoring.user)
  return Math.max(
    user?.synchronousCourseEnrol?.synchronousCourseEnrolAssessments?.length || 1
  )
}
